<template>
  <div>
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      size="mini"
      circle
      @click="addGoods"
      v-if="!readonly"
      style="float:right;margin:10px 15px 10px 0;"
    ></el-button> -->
    <el-table ref="list" border :data="tableData" style="width: 100%" @row-click="rowClick" show-summary :summary-method="getSummaries">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="BarCode" label="条码">
        <template slot-scope="{ row }">
          <span>{{ row.BarCode }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
        <template slot-scope="{ row }">
          <account-select
            v-model="row.GoodsName"
            :source="DAccount"
            @select="onSelect($event, row)"
            v-if="!readonly"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal="listTotal"
            @currentPage="currentPage($event, row)"
            @click.native="resetFun"
            @inputText="inputText($event, row)"
            :pageType="true"
          />
          <span v-else>{{ row.GoodsName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="WarehouseName" label="仓库" width="130">
        <template slot-scope="{ row }">
          <el-select v-model="row.WarehouseId" @change="editT(row)">
            <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="UnitName" label="单位" />
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
          <el-input
            size="mini"
            v-model="row.Offer"
            type="number"
            @input="rateChange(row)"
            @blur="onBlur(row, 'Offer')"
            @focus="onFocus(row, 'Offer')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ $commonJs.toThousands(row.Offer) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Discount" label="折扣%">
        <template slot-scope="{ row }">
          <el-input
            size="mini"
            v-model="row.Discount"
            type="number"
            @input="disChange(row)"
            @blur="onBlur(row, 'Discount')"
            @focus="onFocus(row, 'Discount')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="NoTaxPrice" label="无税单价" v-if="disposeTax == 1">
        <template slot-scope="{ row }">
          {{ $commonJs.toThousands(row.NoTaxPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="TaxRate" label="税率/%" v-if="disposeTax == 1">
        <template slot-scope="{ row }">
          <el-input
            size="mini"
            v-model="row.TaxRate"
            type="number"
            @input="rateChange(row)"
            @blur="onBlur(row, 'TaxRate')"
            @focus="onFocus(row, 'TaxRate')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="数量">
        <template slot-scope="{ row }">
          <el-input
            size="mini"
            v-model="row.Quantity"
            type="number"
            @input="changeNum(row)"
            @blur="onBlur(row, 'Quantity')"
            @focus="onFocus(row, 'Quantity')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Quantity }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
          {{ $commonJs.toThousands(row.Price) }}
        </template>
      </el-table-column>
      <el-table-column prop="TaxAmount" label="税额" v-if="disposeTax == 1">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.TaxAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="Amount" label="含税金额">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.Amount) }}
        </template>
      </el-table-column>
      <el-table-column prop="NoTaxAmount" label="不含税金额" width="90">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.NoTaxAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="num" label="包装数量" />
      <el-table-column label="操作" align="center" width="130px" fixed="right" v-if="!readonly">
        <template slot-scope="scope">
          <el-link icon="el-icon-copy-document" style="margin-right: 10px" @click.stop="copy(scope.row, scope.$index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click.stop="del(scope.row, scope.$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from '@/components/sales/business/listDialog'
import accountSelect from '@/components/sales/business/select'
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false
    },
    disposeTax: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    goodsDialog,
    accountSelect
  },
  data() {
    return {
      sApi: require('@/api/goods/goods').default,
      api: require('@/api/sale/stInDoc').default,
      saleApi: require('@/api/purchase/stock').default,
      account_api: require('@/api/goods/goods').default,
      wareApi: require('@/api/ba/warehouse').default,
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      tableData: [],
      tableDel: [],
      PriAdjustGoodsList: [],
      DAccount: [],
      DefTaxRate: 0,
      initDAccount: [],
      initTotal: 0,
      wareList: []
    }
  },
  mounted() {
    this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7 }).then(res => {
      if (res.Code == 0) (this.DAccount = res.Data), (this.initDAccount = res.Data), (this.initTotal = res.Count)
    })
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      // sessionStorage.setItem("ware", JSON.stringify(res.Data));
    })
  },
  methods: {
    editT(row) {
      row.T = row.T == 0 ? 0 : 1
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0
      if (row.Quantity > 0) {
        row.Quantity = 0 - row.Quantity
      }
      this.count(row)
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage(val, row) {
      let GoodsName = row.GoodsName
      this.pageParams.pageIndex = val
      this.account_api.list({ Status: 1, pageIndex: val, pageSize: 7, GoodsName }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      row.GoodsName = text
      this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    setDefTaxRate(DefTaxRate, type) {
      this.DefTaxRate = DefTaxRate
      if (DefTaxRate != null && type) {
        this.tableData.forEach(e => {
          e.TaxRate = this.DefTaxRate
          this.rateChange(e)
        })
      }
    },
    // 非分页 千位符+保留后两位
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity1', 'NoTaxAmount', 'Quantity2', 'Quantity', 'CostPrice', 'TaxAmount', 'Amount', 'Offer'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            // 数量字段，保留4位小数
            if (['Quantity', 'Quantity1', 'Quantity2'].includes(field)) {
              sums[index] = Math.round(sums[index] * Math.pow(10, 4)) / Math.pow(10, 4)
            } else {
              sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.$refs.list.data.indexOf(row)
        if (index + 1 == this.$refs.list.data.length) {
          //
          this.addGoods()
        }
      }
    },
    onSelect(e, row) {
      row.T = row.T == 0 ? 0 : 1
      row.OrderGoodsId = 0
      row.DocId = this.info.DocId || 0
      row.BarCode = e.BarCode
      row.GoodsName = e.GoodsName
      row.GoodsId = e.GoodsId
      row.Model = e.Model || ''
      row.UnitId = e.MainUnitId || 0
      row.UnitName = e.MainUnitName || ''
      row.Quantity = 0
      row.BatchNo = e.BatchNo || ''
      row.Offer = e.WholesalePrice || 0
      row.Discount = 100
      row.Price = e.WholesalePrice || 0
      row.ExistQuantity = e.ExistQuantity || 0
      row.AvailableQuantity = e.AvailableQuantity || 0
      row.TaxRate = 0
      row.TaxAmount = 0
      row.Amount = 0
      row.NoTaxAmount = 0
      row.PromotionType = 0
      row.PromotionId = 0
      row.ReferenceCost = e.ReferenceCost || 0
      row.GrossProfit = 0
      row.Remark = e.Remark || ''
      row.Thumbnail = ''
      row.OutQuantity = 0
      row.AddTime = this.info.DocDate || today
    },
    getData() {
      this.tableData = []
      this.tableData = this.info.Goods
      // this.saleApi.getGoodsList(this.info.DocId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row, index) {
      this.$confirm('确认删除该行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2
          this.tableDel.push(row)
        }
        if (this.tableData.length == 1) {
          this.tableData.splice(index, 1)
          this.addGoods()
        } else {
          this.tableData.splice(index, 1)
        }
        this.subTable()
      })
    },
    copy(row, index) {
      this.tableData.splice(index, 0, {
        ...row
      })
      this.tableData[index].OrderGoodsId = 0
      this.tableData[index].T = 0
      this.subTable()
    },
    addGoods() {
      // let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1, NotIds: ids });
      // });
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        DocId: 0,
        BarCode: '',
        GoodsName: '',
        GoodsId: '',
        Model: '',
        UnitId: 0,
        UnitName: '',
        Quantity: 0,
        BatchNo: '',
        Offer: 0,
        Discount: 100,
        Price: 0,
        NoTaxPrice: 0,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: this.DefTaxRate,
        TaxAmount: 0,
        Amount: 0,
        NoTaxAmount: 0,
        PromotionType: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: '',
        Thumbnail: '',
        OutQuantity: 0,
        AddTime: '',
        WholesalePrice: ''
      }
      this.tableData.push(goods)
    },
    setGoods(e) {
      let date = new Date()
      let today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      this.sApi.getGoodsPrice({ GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate }).then(res => {
        let goods = {
          T: 0,
          OrderGoodsId: 0,
          DocId: this.info.DocId || 0,
          BarCode: e.BarCode,
          GoodsName: e.GoodsName,
          GoodsId: e.GoodsId,
          Model: e.Model || '',
          UnitId: e.UnitId || 0,
          UnitName: e.UnitName || '',
          Quantity: e.Quantity || '',
          BatchNo: e.BatchNo || '',
          Offer: e.Offer || 0,
          Discount: e.Discount || 100,
          Price: e.Price || 0,
          NoTaxPrice: e.NoTaxPrice || 0,
          ExistQuantity: e.ExistQuantity || 0,
          AvailableQuantity: e.AvailableQuantity || 0,
          TaxRate: e.TaxRate || 0,
          TaxAmount: e.TaxAmount || 0,
          Amount: e.Amount || 0,
          NoTaxAmount: e.NoTaxAmount || 0,
          PromotionType: e.PromotionType || 0,
          PromotionId: e.PromotionId || 0,
          ReferenceCost: e.ReferenceCost || 0,
          GrossProfit: e.GrossProfit || 0,
          Remark: e.Remark || '',
          Thumbnail: '',
          OutQuantity: e.OutQuantity || 0,
          AddTime: this.info.DocDate || today
        }
        // if(res.Data != null) {
        //   goods.Offer = res.Data.VirtualPrice
        // }
        this.tableData.push(goods)
      })
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity);
      this.count(row)
    },
    rateChange(row) {
      this.count(row)
    },
    disChange(row) {
      this.count(row)
    },
    count(row) {
      let price = row.Price ? Number(row.Price) : 0
      let dis = row.Discount > 0 ? Number(row.Discount) : 100
      let qua = row.Quantity ? Number(row.Quantity) : 0
      let rate = row.TaxRate ? Number(row.TaxRate) : 0
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0
      if (row.T !== 0) {
        row.T = 1
      }
      // if(this.disposeTax==1){
      //   row.Price = row.Offer * (1+rate / 100)
      //   row.Price=row.Price.toFixed(1)
      // }else{
      //   row.Price = row.Offer
      // }
      // row.Amount = (row.Price * qua - dis).toFixed(1)
      // row.TaxAmount = (qua*(row.Offer * (rate / 100))).toFixed(1) || 0
      // row.GrossProfit = row.Amount - (qua * ref)
      if (this.disposeTax == 1) {
        row.Price = dis ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2) : (row.Offer * (1 + rate / 100)).toFixed(2)
      } else {
        row.Price = dis ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2) : (row.Offer * (1 + rate / 100)).toFixed(2)
      }
      row.Amount = ((row.Price * qua * 100) / 100).toFixed(2)
      row.NoTaxAmount = (row.Offer * (dis / 100) * row.Quantity).toFixed(2)
      row.NoTaxPrice = dis ? (row.Offer * (dis / 100)).toFixed(2) : row.Offer
      row.TaxAmount = ((qua * ((row.NoTaxPrice * (rate * 10)) / 1000) * 100) / 100).toFixed(2) || 0
      this.subTable()
    },
    subTable() {
      this.$emit('getList', this.tableData.concat(this.tableDel))
    }
  }
}
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
